import type { FallbackProps } from 'react-error-boundary'

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div role="alert" className="p-8 max-w-2xl mx-auto">
      <h2 className="text-lg font-bold text-text-strong mb-2">Something went wrong.</h2>
      <p className="text-sm text-text-muted mb-4">{message}</p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="px-4 py-2 rounded-lg bg-primary text-white text-sm font-semibold hover:bg-primary-hover transition-colors"
      >
        Try again
      </button>
    </div>
  )
}
